import styled from 'styled-components';
import { colors, typography } from '../../../../constants';

const CardText = styled.p`
  color: ${colors.greyDarkest};
  font-weight: ${typography.weights.regular};
  padding: 0;
  margin: 0;
  flex: 1;
`;

export default CardText;
